"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createEntityLite = void 0;
var _utils = require("../utils");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var pathsMap = {
  journey: function journey(fields) {
    return ['orders', (0, _utils.getProp)(fields, 'slug'), 'new'];
  },
  page: function page(fields) {
    var _fields$parent, _fields$subLevel;
    if ((fields === null || fields === void 0 ? void 0 : fields.pageType) === 'home') {
      return [];
    }
    return [(0, _utils.getProp)(fields === null || fields === void 0 ? void 0 : (_fields$parent = fields.parent) === null || _fields$parent === void 0 ? void 0 : _fields$parent.fields, 'slug'), (0, _utils.getProp)(fields === null || fields === void 0 ? void 0 : (_fields$subLevel = fields.subLevel) === null || _fields$subLevel === void 0 ? void 0 : _fields$subLevel.fields, 'slug'), (0, _utils.getProp)(fields, 'slug')];
  },
  page_v2: function page_v2(fields) {
    var _fields$parent2, _fields$subLevel2;
    if ((fields === null || fields === void 0 ? void 0 : fields.pageType) === 'home') {
      return [];
    }
    var paths = [(fields === null || fields === void 0 ? void 0 : fields.pageType) === 'topic' ? 'help-centre' : null, (fields === null || fields === void 0 ? void 0 : fields.pageType) === 'account' ? 'account' : null, (0, _utils.getProp)(fields === null || fields === void 0 ? void 0 : (_fields$parent2 = fields.parent) === null || _fields$parent2 === void 0 ? void 0 : _fields$parent2.fields, 'slug'), (0, _utils.getProp)(fields === null || fields === void 0 ? void 0 : (_fields$subLevel2 = fields.subLevel) === null || _fields$subLevel2 === void 0 ? void 0 : _fields$subLevel2.fields, 'slug'), (0, _utils.getProp)(fields, 'slug')];
    if (paths.find(function (it) {
      return it === null || it === void 0 ? void 0 : it.match(/^\[.*]$/);
    })) {
      return null;
    }
    return paths;
  },
  productPage: function productPage(fields) {
    var _fields$category, _fields$subCategory;
    return [(0, _utils.getProp)(fields === null || fields === void 0 ? void 0 : (_fields$category = fields.category) === null || _fields$category === void 0 ? void 0 : _fields$category.fields, 'slug'), (0, _utils.getProp)(fields === null || fields === void 0 ? void 0 : (_fields$subCategory = fields.subCategory) === null || _fields$subCategory === void 0 ? void 0 : _fields$subCategory.fields, 'slug'), (0, _utils.getProp)(fields, 'slug')];
  },
  person: function person(fields) {
    return ['clinical-team', (0, _utils.getProp)(fields, 'slug')];
  },
  topicPage: function topicPage(fields) {
    var _fields$parent3;
    return ['help-centre', (0, _utils.getProp)(fields === null || fields === void 0 ? void 0 : (_fields$parent3 = fields.parent) === null || _fields$parent3 === void 0 ? void 0 : _fields$parent3.fields, 'slug'), (0, _utils.getProp)(fields, 'slug')];
  },
  // help post url uses canonical
  helpPost: function helpPost(fields) {
    return ['help-centre', (0, _utils.getProp)(fields, 'slug')];
  },
  triagePage: function triagePage(fields) {
    return ['services', (0, _utils.getProp)(fields, 'slug')];
  }
};
var previewPathsMap = {
  resultCard: function resultCard(fields) {
    return ['preview', 'resultCard', (0, _utils.getProp)(fields, 'type')];
  },
  page_v2: function page_v2(fields) {
    if (fields.pageType === 'account') {
      var _fields$parent4, _fields$subLevel3;
      return ['account', (0, _utils.getProp)(fields === null || fields === void 0 ? void 0 : (_fields$parent4 = fields.parent) === null || _fields$parent4 === void 0 ? void 0 : _fields$parent4.fields, 'slug'), (0, _utils.getProp)(fields === null || fields === void 0 ? void 0 : (_fields$subLevel3 = fields.subLevel) === null || _fields$subLevel3 === void 0 ? void 0 : _fields$subLevel3.fields, 'slug'), (0, _utils.getProp)(fields, 'slug')].map(function (it) {
        return it === null || it === void 0 ? void 0 : it.replace('[sh24Uid]', 'abc123');
      });
    }
    return null;
  }
};
var buildUrl = function buildUrl(paths) {
  if (!paths) return null;
  return (0, _utils.buildEntityUrl)(paths);
};

/**
 * Creates a `entityLite` content model
 *
 * @param {object} entry
 * @param {object} entry.sys
 * @param {string} entry.sys.id
 * @param {object} entry.fields
 * @returns {object} `entityLite` content model
 */
var createEntityLite = function createEntityLite(_ref) {
  var _sys$contentType, _sys$contentType$sys;
  var sys = _ref.sys,
    fields = _ref.fields;
  var contentType = sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : (_sys$contentType$sys = _sys$contentType.sys) === null || _sys$contentType$sys === void 0 ? void 0 : _sys$contentType$sys.id;
  var pathsFactory = pathsMap[contentType] || null;
  var previewPathsFactory = previewPathsMap[contentType] || null;
  var url = buildUrl(pathsFactory === null || pathsFactory === void 0 ? void 0 : pathsFactory(fields));
  var previewUrlOverride = buildUrl(previewPathsFactory === null || previewPathsFactory === void 0 ? void 0 : previewPathsFactory(fields));
  var previewUrl = previewUrlOverride !== null && previewUrlOverride !== void 0 ? previewUrlOverride : url;
  return _objectSpread(_objectSpread(_objectSpread({
    id: (0, _utils.getProp)(sys, 'id')
  }, url ? {
    url: url
  } : {}), previewUrl ? {
    previewUrl: previewUrl
  } : {}), {}, {
    lastUpdated: (0, _utils.getProp)(fields, 'lastUpdated') || (0, _utils.getProp)(sys, 'updatedAt')
  });
};

/**
 * Returns the first entity from
 * an array of Contentful Entries
 *
 * @param {array<object>} items
 * @returns
 */
exports.createEntityLite = createEntityLite;
var entityLiteFactory = function entityLiteFactory(items) {
  return createEntityLite(items.shift());
};
var _default = entityLiteFactory;
exports["default"] = _default;